type LogLevel = "log" | "warn" | "error";
type DevLogEntry = {
  ts: string;
  channel: string;
  message: string;
  data: unknown;
};

const MAX_DEV_LOG_ENTRIES = 80;

const appendToWindowDebugBuffer = (payload: DevLogEntry) => {
  if (typeof window === "undefined") return;
  const debugWindow = window as typeof window & {
    __COLDCLIENT_DEBUG_LOGS__?: DevLogEntry[];
  };
  const nextEntries = [...(debugWindow.__COLDCLIENT_DEBUG_LOGS__ || []), payload].slice(-MAX_DEV_LOG_ENTRIES);
  debugWindow.__COLDCLIENT_DEBUG_LOGS__ = nextEntries;
};

const isEnabled = () => {
  if (!import.meta.env.DEV) return false;
  const flag = String(import.meta.env.VITE_DEBUG_LOGS ?? "true").toLowerCase();
  return flag !== "0" && flag !== "false" && flag !== "off";
};

const emit = (level: LogLevel, channel: string, message: string, data?: unknown) => {
  if (!isEnabled()) return;
  const payload = {
    ts: new Date().toISOString(),
    channel,
    message,
    data: data ?? null,
  };
  appendToWindowDebugBuffer(payload);
  if (level === "error") {
    console.error("[ColdClientDebug]", payload);
    return;
  }
  if (level === "warn") {
    console.warn("[ColdClientDebug]", payload);
    return;
  }
  console.log("[ColdClientDebug]", payload);
};

export const devLog = (channel: string, message: string, data?: unknown) =>
  emit("log", channel, message, data);

export const devWarn = (channel: string, message: string, data?: unknown) =>
  emit("warn", channel, message, data);

export const devError = (channel: string, message: string, data?: unknown) =>
  emit("error", channel, message, data);

export const getRecentDevLogs = () => {
  if (typeof window === "undefined") return [];
  const debugWindow = window as typeof window & {
    __COLDCLIENT_DEBUG_LOGS__?: DevLogEntry[];
  };
  return [...(debugWindow.__COLDCLIENT_DEBUG_LOGS__ || [])];
};
